import { ACCOUNTING_CHECKLIST_FILTERS } from './accountingChecklistFilters.js';
import bankingOperations from './banking-operations-filters';
import bankingOperationsSettle from './banking-operations-settle-filters';
import billingFilters from './billing-filters';
import billingSettleFilters from './billing-settle-filters';
import mailingInboxFilters from './crm-mail-filters';
import { CLIENTS_LISTING_FILTERS } from './crmClientsFilters';
import { DETAILED_ACCOUNTING_CHECKLIST_FILTERS } from './detailedAccountingChecklistFilters.js';
import evidenceAllFilters from './evidence-all-filters.js';
import { EVIDENCE_DESCRIPTIONS_LISTING_FILTERS } from './evidence-descriptions';
import { INVOICE_KLA_FILTERS } from './invoiceKLAFilters';
import { INVOICE_MANUAL_FILTERS } from './invoiceManualFilters';
import { INVOICE_PAYMENT_DUE_FILTERS } from './invoicePaymentDueFilters';
import khEvidenceFilters from './kh-evidence-filters.js';
import khPurchasesFilters from './kh-purchases-filters.js';
import khSalesFilters from './kh-sales-filters.js';
import { KPIR_EVIDENCE_LISTING_FILTERS } from './kpirEvidenceFilters';
import { KPIR_PURCHASES_LISTING_FILTERS } from './kpirPurchasesFilters';
import { KPIR_SALES_LISTING_FILTERS } from './kpirSalesFilters';
import {
  ARCHIVED_KSEF_INVOICES_LISTING_FILTERS,
  KSEF_PURCHASES_LISTING_FILTERS,
  KSEF_SALE_LISTING_FILTERS,
} from './ksef-purchases-listing-filters';
import leaveFilters from './leave-filters';
import mailingGroupFilters from './mail-group-filters';
import mailingTemplateFilters from './mail-template-filters';
import mailingFilters from './mailing-filters';
import { MAILING_GROUP_CRM } from './mailing-group-crms';
import { MAILING_GROUP_CRM_EDIT } from './mailing-group-crms-edit';
import partnerCrmFilters from './partner-crm-filters';
import partnerStaffBoardMemberFilters from './partner-staff-board-member-filters';
import partnerStaffFilters from './partner-staff-filters';
import { RYCZALT_EVIDENCE_LISTING_FILTERS } from './ryczaltEvidenceFilters';
import { RYCZALT_PURCHASES_LISTING_FILTERS } from './ryczaltPurchasesFilters';
import { RYCZALT_SALES_LISTING_FILTERS } from './ryczaltSalesFilters';
import { SEND_MAIL_STEPPER_EDIT_FILTERS } from './send-mail-stepper-edit-filters';
import { SEND_MAIL_STEPPER_FILTERS } from './send-mail-stepper-filters';
import { SEND_MAIL_STEPPER_FORWARD_FILTERS } from './send-mail-stepper-forward-filters';
import { SEND_MAIL_STEPPER_FORWARD_OWN_FILTERS } from './send-mail-stepper-forward-own-filters';
import { SEND_MAIL_STEPPER_REPLY_FILTERS } from './send-mail-stepper-reply-filters';
import systemBalanceListFilters from './system-balance-list-filters';
import zusDeclarationsFilters from './zus-declarations-filters';

export default [
  ACCOUNTING_CHECKLIST_FILTERS,
  ARCHIVED_KSEF_INVOICES_LISTING_FILTERS,
  bankingOperations,
  bankingOperationsSettle,
  billingFilters,
  billingSettleFilters,
  CLIENTS_LISTING_FILTERS,
  DETAILED_ACCOUNTING_CHECKLIST_FILTERS,
  EVIDENCE_DESCRIPTIONS_LISTING_FILTERS,
  evidenceAllFilters,
  INVOICE_KLA_FILTERS,
  INVOICE_MANUAL_FILTERS,
  INVOICE_PAYMENT_DUE_FILTERS,
  khEvidenceFilters,
  khPurchasesFilters,
  khSalesFilters,
  KPIR_EVIDENCE_LISTING_FILTERS,
  KPIR_PURCHASES_LISTING_FILTERS,
  KPIR_SALES_LISTING_FILTERS,
  KSEF_PURCHASES_LISTING_FILTERS,
  KSEF_SALE_LISTING_FILTERS,
  leaveFilters,
  MAILING_GROUP_CRM,
  MAILING_GROUP_CRM_EDIT,
  mailingFilters,
  mailingGroupFilters,
  mailingInboxFilters,
  mailingTemplateFilters,
  partnerCrmFilters,
  partnerStaffBoardMemberFilters,
  partnerStaffFilters,
  RYCZALT_EVIDENCE_LISTING_FILTERS,
  RYCZALT_PURCHASES_LISTING_FILTERS,
  RYCZALT_SALES_LISTING_FILTERS,
  SEND_MAIL_STEPPER_EDIT_FILTERS,
  SEND_MAIL_STEPPER_FILTERS,
  SEND_MAIL_STEPPER_FORWARD_FILTERS,
  SEND_MAIL_STEPPER_FORWARD_OWN_FILTERS,
  SEND_MAIL_STEPPER_REPLY_FILTERS,
  systemBalanceListFilters,
  zusDeclarationsFilters,
];
